import React, { useState } from 'react';
import SecondaryBtnComponent from '../buttonComponent/SecondaryBtnComponent';
import Modal from '@mui/material/Modal';
import { PHONE_VERIFICATION_TEXTS } from '../../shared/constants';
import { Box, Typography } from '@mui/material';
import BtnComponent from '../buttonComponent/BtnComponent';
import Close from '@mui/icons-material/Close';
import FormComponent from '../FormComponent/FormComponent';
import { useMutation } from '@apollo/client';
import { VERIFY_USER_IN_KEYCLOAK } from '../../services/userQueries/userService';
import { SimpleBackdrop } from '../SimpleBackdropComponent/SimpleBackdrop';
import {
  getFormattedInputBasedOnFieldName,
  getUSFormatPhoneNo,
  isObjectEmpty,
} from '../../shared/helper';
import { useSnackbar } from 'notistack';
import { ERROR_MSGS, OTP_VERIFICATION } from '../../shared/Strings';

const createAccountValues = {
  phonenumber: '',
};
const buttonWrapper = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  mt: 4,
};
const btnComponent = {
  ml: 1,
  width: '100%',
  maxWidth: '250px',
};
const secButton = {
  maxWidth: '117px',
  marginRight: '16px',
};
const modalWrapper = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  p: 1,
};
const modalwrapperBox = {
  bgcolor: '#FFFFFF',
  width: '100%',
  maxWidth: '560px',
  borderRadius: '24px',
  outline: 'none',
  height: '276px',
};
const textWrapperContainer = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  px: '32px',
  pt: '26px',
};

const EditPhoneNumber = props => {
  const { enqueueSnackbar } = useSnackbar();
  const [accountFormErrors, setAccountFormErrors] = useState({});
  const [accountFormValues, setAccountFormValues] =
    useState(createAccountValues);

  const [checkExistingUser, checkExistingUserCall] = useMutation(
    VERIFY_USER_IN_KEYCLOAK,
    {
      fetchPolicy: 'no-cache',
    }
  );

  const handleSubmit = e => {
    e.preventDefault();
    const formattedPhoneNumber = e?.target?.elements?.phonenumber?.value;
    const actualPhoneNumber = getFormattedInputBasedOnFieldName(
      'phonenumber',
      formattedPhoneNumber
    );
    setAccountFormErrors(accountValidate(accountFormValues));
    if (isObjectEmpty(accountValidate(accountFormValues))) {
      if (actualPhoneNumber === props?.existingPhoneNumber) {
        props.handleSaveChanges(actualPhoneNumber);
        props.setPopupChangePhoneNo(false);
      } else {
        checkExistingUser({
          variables: {
            verifyUserRequest: {
              phoneNumber: actualPhoneNumber,
              emailId: '',
            },
          },
        })
          .then(result => {
            enqueueSnackbar(ERROR_MSGS.PHONE_ALREADY_EXIST, {
              variant: 'error',
            });
          })
          .catch(err => {
            props.handleSaveChanges(actualPhoneNumber);
            props.setPopupChangePhoneNo(false);
          });
      }
    }
  };

  const handleChange = e => {
    const { name, value } = e.target;
    if (name === 'phonenumber') {
      setAccountFormValues({
        ...accountFormValues,
        [name]: getUSFormatPhoneNo(value),
      });
    } else {
      setAccountFormValues({ ...accountFormValues, [name]: value });
    }
  };

  const ClosepopUp = () => {
    props.setPopupChangePhoneNo(false);
  };
  const accountValidate = values => {
    const errors = {};
    const phoneNumberRegex = /^[2-9]\d{2}\d{3}\d{4}$/i;

    if (!values.phonenumber) {
      errors.phonenumber = ERROR_MSGS.REQUIRED_FIELD.PHONE_NUMBER;
    } else if (values.phonenumber.length !== 14) {
      errors.phonenumber = ERROR_MSGS.PHONE_NUMBER_TEN_DIGIT;
    } else if (
      !phoneNumberRegex.test(
        getFormattedInputBasedOnFieldName('phonenumber', values.phonenumber)
      )
    ) {
      errors.phonenumber = ERROR_MSGS.INVALID_PHONE;
    }

    return errors;
  };
  const inputFieldArray = [
    {
      title: OTP_VERIFICATION.PHONE_NUMBER,
      placeholder: OTP_VERIFICATION.EDIT_PHONE,
      helperText: OTP_VERIFICATION.CONFIRM_SEND_OTP,
      type: 'text',
      onChange: handleChange,
      name: 'phonenumber',
      value: accountFormValues.phonenumber,
      errorMessage: accountFormErrors.phonenumber,
      adornment: '+1',
      adornmentPosition: 'start',
    },
  ];

  return (
    <>
      <Modal
        open={props.popupChangePhoneNo}
        onClose={ClosepopUp}
        sx={modalWrapper}>
        <Box sx={modalwrapperBox}>
          <Box sx={textWrapperContainer}>
            <Typography
              sx={{
                color: '#000000',
                fontSize: '28px',
                fontWeight: 600,
              }}>
              {PHONE_VERIFICATION_TEXTS.EDIT_PHONE_NO}
            </Typography>
            <Close sx={{ pt: '10px' }} onClick={ClosepopUp} />
          </Box>
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ pl: '32px', mt: '28px', width: '360px' }}>
            <FormComponent inputFieldArray={inputFieldArray} />
            <Box sx={buttonWrapper}>
              <SecondaryBtnComponent
                onClick={ClosepopUp}
                sx={secButton}
                title={OTP_VERIFICATION.BUTTON_TEXT.CANCEL}
                variant="outlined"
              />
              <BtnComponent
                type="submit"
                title={OTP_VERIFICATION.BUTTON_TEXT.SAVE_CHANGES}
                size="large"
                //onClick={handleSave}
                sx={btnComponent}
                fullWidth
              />
            </Box>
          </Box>
        </Box>
      </Modal>
      <SimpleBackdrop open={checkExistingUserCall.loading} />
    </>
  );
};

export default EditPhoneNumber;
